import localeGB from "antd/es/date-picker/locale/en_GB";
import localeIT from "antd/es/date-picker/locale/it_IT";

export const ENVIRONMENT = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  API_REST_BE: process.env.REACT_APP_API_REST_BE,
  DEPLOY_ENV_NAME: process.env.REACT_APP_DEPLOY_ENV_NAME,
};

export const roles = {
  SYSTEM_IT: "SYSTEM_IT",
  SUPER_PM: "SUPER_PM",
  SUPPORT_PM: "SUPPORT_PM",
  PM: "PM",
  DM: "DM",
  CONTROLLER: "CONTROLLER",
  CONSULTATION: "CONSULTATION",
  SUPPLIER: "SUPPLIER",
  COST_ESTIMATING: "COST_ESTIMATING",
  TIMESHEET: "TIMESHEET",
  RESP_CDC: "RESP_CDC",
  TIMESHEET_SUBSTITUTE: "TIMESHEET_SUBSTITUTE",
  EXPENSE_REFUND_ADMIN: "EXPENSE_REFUND_ADMIN",
  HR: "HR",
  ACCOUNTING: "ACCOUNTING",
  EXPENSE_REFUND: "EXPENSE_REFUND",
  EXPENSE_REFUND_SUBST: "EXPENSE_REFUND_SUBST",
  EXPENSE_REFUND_VIEW: "EXPENSE_REFUND_VIEW",
  TIMESHEET_APPROVER: "TIMESHEET_APPROVER",
  SAL_SUBSTITUTE: "SAL_SUBSTITUTE",
};

export const menuItems = [
  {
    labelkey: "pfp",
    key: "pfp",
    children: [
      {
        labelkey: "administration",
        key: "administration",
        children: [
          {
            labelkey: "settings",
            key: "/settings",
            roles: ["SYSTEM_IT"],
          },
          {
            labelkey: "userSuppliers",
            key: "/user-suppliers",
            roles: ["SYSTEM_IT"],
          },
          {
            labelkey: "internalUsers",
            key: "/internal-users",
            roles: ["SYSTEM_IT"],
          },
          {
            labelkey: "clients",
            key: "/clients",
            roles: ["SYSTEM_IT", "CONTROLLER"],
          },
          {
            labelkey: "expenseCenters",
            key: "/expense-centers",
            roles: ["SYSTEM_IT"],
          },
          {
            labelkey: "productCategories",
            key: "/product-categories",
            roles: ["SYSTEM_IT"],
          },
          {
            labelkey: "projects",
            key: "/projects",
            roles: ["SYSTEM_IT", "CONTROLLER"],
          },
          {
            labelkey: "jobs",
            key: "/jobs",
            roles: ["SYSTEM_IT"],
          },
          {
            labelkey: "status",
            key: "/status",
            roles: ["SYSTEM_IT", "CONTROLLER"],
          },
          {
            labelkey: "salesOrder",
            key: "/sales-order",
            roles: ["SYSTEM_IT", "CONTROLLER"],
          },
          {
            labelkey: "vertical",
            key: "/vertical",
            roles: ["SYSTEM_IT", "CONTROLLER"],
          },
          {
            labelkey: "services",
            key: "/services",
            roles: ["SYSTEM_IT"],
          },
          {
            labelkey: "serviceRates",
            key: "/service-rates",
            roles: ["SYSTEM_IT"],
          },
          {
            labelkey: "wbsCategories",
            key: "/wbs-categories",
            roles: ["SYSTEM_IT", "CONTROLLER"],
          },
          {
            labelkey: "wbsStructure",
            key: "/wbs-structure",
            roles: ["SYSTEM_IT", "CONTROLLER"],
          },
          {
            labelkey: "exportSap",
            key: "/export-sap",
            roles: ["SYSTEM_IT"],
          },
          {
            labelkey: "exportBpc",
            key: "/export-bpc",
            roles: ["SYSTEM_IT", "CONTROLLER", "PM"],
          },
          {
            labelkey: "exportSf",
            key: "/export-sf",
            roles: ["SYSTEM_IT", "CONTROLLER"],
          },
          {
            labelkey: "monthPlanning",
            key: "/month-planning",
            roles: ["SYSTEM_IT", "CONTROLLER"],
          },
        ],
      },
      {
        labelkey: "controlAndPianification",
        key: "controlAndPianification",
        children: [
          {
            labelkey: "projectEstimate",
            key: "/project-estimate",
            roles: ["SYSTEM_IT", "COST_ESTIMATING", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
          },
          {
            labelkey: "projectsManagement",
            key: "/projects-management",
            roles: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
          },
          {
            labelkey: "reportCp",
            key: "/report-CP",
            roles: [
              "SYSTEM_IT",
              "CONTROLLER",
              "SUPER_PM",
              "RESP_CDC",
              "PM",
              "SUPPORT_PM",
              "TIMESHEET_APPROVER",
              "CONSULTATION",
            ],
          },
        ],
      },
      {
        labelkey: "supplierAdministration",
        key: "supplierAdministration",
        children: [
          {
            labelkey: "odaAllocation",
            key: "/oda-allocation",
            roles: ["SYSTEM_IT", "DM"],
          },
          {
            labelkey: "salDeclaration",
            key: "/sal-declaration",
            roles: ["SYSTEM_IT", "SUPPLIER", "SAL_SUBSTITUTE"],
          },
          {
            labelkey: "salApproval",
            key: "/sal-approval",
            roles: ["SYSTEM_IT", "SUPER_PM", "PM", "TIMESHEET_APPROVER"],
          },
          {
            labelkey: "report",
            key: "/report",
            roles: ["SYSTEM_IT", "SUPER_PM", "SUPPORT_PM", "PM", "CONTROLLER", "CONSULTATION", "SUPPLIER", "DM"],
          },
        ],
      },
    ],
  },
  {
    labelkey: "timesheet",
    key: "timesheet",
    children: [
      {
        labelkey: "personalTimesheet",
        key: "/personal-timesheet",
        roles: ["TIMESHEET"],
      },
      {
        labelkey: "timesheetUser",
        key: "/timesheet",
        roles: ["SYSTEM_IT", "TIMESHEET_SUBSTITUTE"],
      },
      {
        labelkey: "timesheetApproval",
        key: "/timesheet-approval",
        roles: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM", "TIMESHEET_APPROVER"],
      },
      {
        labelkey: "report",
        key: "/timesheet/report",
        roles: [
          "SYSTEM_IT",
          "CONTROLLER",
          "PM",
          "SUPER_PM",
          "SUPPORT_PM",
          "TIMESHEET_APPROVER",
          "TIMESHEET_SUBSTITUTE",
          "RESP_CDC",
        ],
      },
      {
        labelkey: "timesheetExport",
        key: "/timesheet-export",
        roles: ["SYSTEM_IT", "CONTROLLER"],
      },
    ],
  },
  {
    labelkey: "expenseRefund",
    key: "expenseRefund",
    children: [
      {
        labelkey: "expenseReportAdmin",
        key: "expenseReportAdmin",
        children: [
          {
            labelkey: "parkAuto",
            key: "/park-auto",
            roles: ["SYSTEM_IT", "HR", "EXPENSE_REFUND_ADMIN"],
          },
          {
            labelkey: "carFuelRefund",
            key: "/car-fuel-refund",
            roles: ["SYSTEM_IT", "HR", "EXPENSE_REFUND_ADMIN"],
          },
          {
            labelkey: "fuelCard",
            key: "/fuel-card",
            roles: ["SYSTEM_IT", "HR", "EXPENSE_REFUND_ADMIN"],
          },
          {
            labelkey: "carEngineType",
            key: "/car-engine-type",
            roles: ["SYSTEM_IT", "HR", "EXPENSE_REFUND_ADMIN"],
          },
          {
            labelkey: "expenseAccountType",
            key: "/expense-account-type",
            roles: ["SYSTEM_IT", "ACCOUNTING", "EXPENSE_REFUND_ADMIN"],
          },
          {
            labelkey: "creditCard",
            key: "/credit-card",
            roles: ["SYSTEM_IT", "HR", "EXPENSE_REFUND_ADMIN"],
          },
          {
            labelkey: "flatRateAmount",
            key: "/flat-rate-amount",
            roles: ["SYSTEM_IT", "HR", "EXPENSE_REFUND_ADMIN"],
          },
          {
            labelkey: "flatRatePeriod",
            key: "/flat-rate-period",
            roles: ["SYSTEM_IT", "HR", "EXPENSE_REFUND_ADMIN"],
          },
          {
            labelkey: "flatRateLocation",
            key: "/flat-rate-location",
            roles: ["SYSTEM_IT", "HR", "EXPENSE_REFUND_ADMIN"],
          },
          {
            labelkey: "exportReport",
            key: "/export-report",
            roles: ["SYSTEM_IT", "HR", "EXPENSE_REFUND_ADMIN"],
          },
          {
            labelkey: "exportDocuments",
            key: "/export-documents",
            roles: ["SYSTEM_IT", "HR", "EXPENSE_REFUND_ADMIN"],
          },
        ],
      },
      {
        labelkey: "expenseRefundFolder",
        key: "/expense-refund-folder",
        roles: ["SYSTEM_IT", "EXPENSE_REFUND"],
      },
      {
        labelkey: "expenseRefundFolderUsers",
        key: "/expense-refund-folder-users",
        roles: ["SYSTEM_IT", "EXPENSE_REFUND_VIEW", "EXPENSE_REFUND_SUBST"],
      },
      {
        labelkey: "approveExpenseReport",
        key: "/approve-expense-report",
        roles: ["SYSTEM_IT", "HR", "ACCOUNTING", "PM", "RESP_CDC", "EXPENSE_REFUND_ADMIN", "EXPENSE_REFUND_VIEW"],
      },
      {
        labelkey: "disapproveExpenseReport",
        key: "/disapprove-expense-report",
        roles: ["SYSTEM_IT", "EXPENSE_REFUND_ADMIN", "ACCOUNTING"],
      },
    ],
  },
  {
    labelkey: "finance",
    key: "finance",
    children: [
      {
        labelkey: "settingLg",
        key: "/setting-lg",
        roles: ["SYSTEM_IT", "ACCOUNTING"],
      },
      {
        labelkey: "lg",
        key: "/lg",
        roles: ["SYSTEM_IT", "ACCOUNTING"],
      },
      {
        labelkey: "reportLg",
        key: "/report-lg",
        roles: ["SYSTEM_IT", "ACCOUNTING"],
      },
    ],
  },
];

// export const userMenu = {
//   administration: [
//     {
//       name: 'settings',
//       link: '/settings',
//       roles: ['SYSTEM_IT']
//     },
//     {
//       name: 'userSuppliers',
//       link: '/user-suppliers',
//       roles: ['SYSTEM_IT']
//     },
//     {
//       name: 'internalUsers',
//       link: '/internal-users',
//       roles: ['SYSTEM_IT']
//     },
//     {
//       name: 'clients',
//       link: '/clients',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     },
//     {
//       name: 'expenseCenters',
//       link: '/expense-centers',
//       roles: ['SYSTEM_IT']
//     },
//     {
//       name: 'productCategories',
//       link: '/product-categories',
//       roles: ['SYSTEM_IT']
//     },
//     {
//       name: 'projects',
//       link: '/projects',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     },
//     {
//       name: 'jobs',
//       link: '/jobs',
//       roles: ['SYSTEM_IT']
//     },
//     {
//       name: 'status',
//       link: '/status',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     },
//     {
//       name: 'salesOrder',
//       link: '/sales-order',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     },
//     {
//       name: 'vertical',
//       link: '/vertical',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     },
//     {
//       name: 'services',
//       link: '/services',
//       roles: ['SYSTEM_IT']
//     },
//     {
//       name: 'serviceRates',
//       link: '/service-rates',
//       roles: ['SYSTEM_IT']
//     },
//     {
//       name: 'wbsCategories',
//       link: '/wbs-categories',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     },
//     {
//       name: 'wbsStructure',
//       link: '/wbs-structure',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     },
//     {
//       name: 'exportSap',
//       link: '/export-sap',
//       roles: ['SYSTEM_IT']
//     },
//     {
//       name: 'exportBpc',
//       link: '/export-bpc',
//       roles: ['SYSTEM_IT', 'CONTROLLER', 'PM']
//     },
//     {
//       name: 'exportSf',
//       link: '/export-sf',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     },
//     {
//       name: 'monthPlanning',
//       link: '/month-planning',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     }
//   ],
//   expenseReportAdmin: [
//     {
//       name: 'parkAuto',
//       link: '/park-auto',
//       roles: ['SYSTEM_IT', 'HR', 'EXPENSE_REFUND_ADMIN']
//     },
//     {
//       name: 'carFuelRefund',
//       link: '/car-fuel-refund',
//       roles: ['SYSTEM_IT', 'HR', 'EXPENSE_REFUND_ADMIN']
//     },
//     {
//       name: 'fuelCard',
//       link: '/fuel-card',
//       roles: ['SYSTEM_IT', 'HR', 'EXPENSE_REFUND_ADMIN']
//     },
//     {
//       name: 'carEngineType',
//       link: '/car-engine-type',
//       roles: ['SYSTEM_IT', 'HR', 'EXPENSE_REFUND_ADMIN']
//     },
//     {
//       name: 'expenseAccountType',
//       link: '/expense-account-type',
//       roles: ['SYSTEM_IT', 'ACCOUNTING', 'EXPENSE_REFUND_ADMIN']
//     },
//     {
//       name: 'creditCard',
//       link: '/credit-card',
//       roles: ['SYSTEM_IT', 'HR', 'EXPENSE_REFUND_ADMIN']
//     },
//     {
//       name: 'flatRateAmount',
//       link: '/flat-rate-amount',
//       roles: ['SYSTEM_IT', 'HR', 'EXPENSE_REFUND_ADMIN']
//     },
//     {
//       name: 'flatRatePeriod',
//       link: '/flat-rate-period',
//       roles: ['SYSTEM_IT', 'HR', 'EXPENSE_REFUND_ADMIN']
//     },
//     {
//       name: 'flatRateLocation',
//       link: '/flat-rate-location',
//       roles: ['SYSTEM_IT', 'HR', 'EXPENSE_REFUND_ADMIN']
//     },
//     {
//       name: 'exportReport',
//       link: '/export-report',
//       roles: ['SYSTEM_IT', 'HR', 'EXPENSE_REFUND_ADMIN']
//     }
//   ],
//   controlAndPianification: [
//     {
//       name: 'projectEstimate',
//       link: '/project-estimate',
//       roles: ['SYSTEM_IT', 'COST_ESTIMATING', 'PM', 'SUPER_PM', 'SUPPORT_PM', 'CONTROLLER']
//     },
//     {
//       name: 'projectsManagement',
//       link: '/projects-management',
//       roles: ['SYSTEM_IT', 'PM', 'SUPER_PM', 'SUPPORT_PM', 'CONTROLLER']
//     },
//     {
//       name: 'reportCp',
//       link: '/report-CP',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     }
//   ],
//   supplierAdministration: [
//     {
//       name: 'odaAllocation',
//       link: '/oda-allocation',
//       roles: ['SYSTEM_IT', 'DM']
//     },
//     {
//       name: 'salDeclaration',
//       link: '/sal-declaration',
//       roles: ['SYSTEM_IT', 'SUPPLIER']
//     },
//     {
//       name: 'salApproval',
//       link: '/sal-approval',
//       roles: ['SYSTEM_IT', 'SUPER_PM', 'PM']
//     },
//     {
//       name: 'report',
//       link: '/report',
//       roles: ['SYSTEM_IT', 'SUPER_PM', 'SUPPORT_PM', 'PM', 'CONTROLLER', 'CONSULTATION', 'SUPPLIER', 'DM']
//     }
//   ],
//   expenseReport: [
//     {
//       name: 'expenseRefundFolder',
//       link: '/expense-refund-folder',
//       roles: Object.keys(roles) // evryone can see this voice menu
//     },
//     {
//       name: 'expenseRefundFolderUsers',
//       link: '/expense-refund-folder-users',
//       roles: ['SYSTEM_IT']
//     },
//     {
//       name: 'approveExpenseReport',
//       link: '/approve-expense-report',
//       roles: ['SYSTEM_IT', 'HR', 'ACCOUNTING', 'PM', 'RESP_CDC', 'EXPENSE_REFUND_ADMIN']
//     }
//   ],
//   timesheet: [
//     {
//       name: 'personalTimesheet',
//       link: '/personal-timesheet',
//       roles: ['TIMESHEET']
//     },
//     {
//       name: 'timesheetUser',
//       link: '/timesheet',
//       roles: ['SYSTEM_IT', 'RESP_CDC', 'TIMESHEET_SUBSTITUTE']
//     },
//     {
//       name: 'timesheetApproval',
//       link: '/timesheet-approval',
//       roles: ['SYSTEM_IT', 'PM', 'SUPER_PM', 'SUPPORT_PM', 'RESP_CDC']
//     },
//     {
//       name: 'report',
//       link: '/timesheet/report',
//       roles: ['SYSTEM_IT', 'CONTROLLER', 'PM', 'SUPER_PM', 'SUPPORT_PM', 'RESP_CDC', 'TIMESHEET_SUBSTITUTE']
//     },
//     {
//       name: 'timesheetExport',
//       link: '/timesheet-export',
//       roles: ['SYSTEM_IT', 'CONTROLLER']
//     },
//   ],
//   finance: [
//     {
//       name: 'settingLg',
//       link: '/setting-lg',
//       roles: ['SYSTEM_IT', 'ACCOUNTING']
//     },
//     {
//       name: 'lg',
//       link: '/lg',
//       roles: ['SYSTEM_IT', 'ACCOUNTING']
//     },
//     {
//       name: 'reportLg',
//       link: '/report-lg',
//       roles: ['SYSTEM_IT', 'ACCOUNTING']
//     }
//   ]
// };

export const rolesInfo = {
  SYSTEM_IT: [
    "alertControllerProjectSupportPm",
    "alertPmApprovalProposal",
    "alertDmOrdersProjectTask",
    "alertSupplierRefutedProposal",
  ],
  SUPER_PM: ["alertPmApprovalProposal"],
  SUPPORT_PM: ["alertPmApprovalProposal"],
  PM: ["alertPmApprovalProposal"],
  DM: ["alertDmOrdersProjectTask"],
  CONTROLLER: ["alertControllerProjectSupportPm"],
  CONSULTATION: [],
  SUPPLIER: ["alertSupplierRefutedProposal"],
  MASTER: [],
  COST_ESTIMATING: [],
  TIMESHEET: [],
  RESP_CDC: [],
  TIMESHEET_SUBSTITUTE: [],
  EXPENSE_REFUND_ADMIN: [],
  HR: [],
  ACCOUNTING: [],
  SAL_SUBSTITUTE: [],
};

export const productCategoryTypes = [
  {
    value: "PERCENT",
    label: "percent",
  },
  {
    value: "HOUR",
    label: "hour",
  },
];

export const unitPriceTypes = [
  {
    value: "INTERNAL",
    label: "internal",
  },
  {
    value: "EXTERNAL",
    label: "external",
  },
];

export const paginationDefaults = {
  page: 1,
  size: 10,
  total: 0,
};

export const dbDate = "YYYY-MM-DD";
export const langDate = {
  gb: "YYYY/MM/DD",
  locale_gb: localeGB,
  it: "DD/MM/YYYY",
  locale_it: localeIT,
};
export const dbDateHour = "YYYY-MM-DD HH:mm:ss";
export const langDateHour = {
  gb: "YYYY/MM/DD HH:mm",
  locale_gb: localeGB,
  it: "DD/MM/YYYY HH:mm",
  locale_it: localeIT,
};

export const dbMonth = "YYYY-MM";
export const dbMonthLg = "YYYYMM";
export const langMonth = {
  gb: "YYYY/MM",
  locale_gb: localeGB,
  it: "MM/YYYY",
  locale_it: localeIT,
};

export const reportTabs = [
  {
    name: "odaAllocation",
    component: "reportDM",
    roles: ["SYSTEM_IT", "CONTROLLER", "DM", "CONSULTATION"],
  },
  {
    name: "servicesPerformed",
    component: "reportSuppliers",
    roles: ["SYSTEM_IT", "CONTROLLER", "DM", "SUPPLIER", "CONSULTATION"],
  },
  {
    name: "serviceReceipts",
    component: "reportPM",
    roles: ["SYSTEM_IT", "CONTROLLER", "PM", "SUPER_PM", "SUPPORT_PM", "CONSULTATION"],
  },
  {
    name: "masterReport",
    component: "reportMaster",
    roles: ["SYSTEM_IT", "CONTROLLER", "PM", "SUPER_PM", "SUPPORT_PM", "CONSULTATION"],
  },
];

export const projectEstimateTabs = {
  preventiveForm: {
    component: "PreventiveForm",
    edit: ["SYSTEM_IT", "COST_ESTIMATING", "PM", "SUPER_PM", "SUPPORT_PM"],
    view: ["SYSTEM_IT", "COST_ESTIMATING", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
  resources: {
    component: "Team",
    edit: ["SYSTEM_IT", "COST_ESTIMATING", "PM", "SUPER_PM", "SUPPORT_PM"],
    view: ["SYSTEM_IT", "COST_ESTIMATING", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
  costEstimation: {
    component: "CostEstimation",
    edit: ["SYSTEM_IT", "COST_ESTIMATING"],
    view: ["SYSTEM_IT", "COST_ESTIMATING", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
  kickOff: {
    component: "KickOff",
    edit: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM"],
    view: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
  rap: {
    component: "Rap",
    edit: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM"],
    view: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
};

export const projectsManagementTabs = {
  ProjectForm: {
    component: "ProjectForm",
    edit: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM"],
    view: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
  Team: {
    component: "Team",
    edit: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM"],
    view: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
  Planning: {
    component: "Planning",
    edit: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM"],
    view: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
  adjPlanning: {
    component: "Planning",
    edit: ["SYSTEM_IT", "CONTROLLER"],
    view: [],
  },
  RiskAnalysis: {
    component: "RiskAnalysis",
    edit: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM"],
    view: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
  IncomeStatement: {
    component: "IncomeStatement",
    edit: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM"],
    view: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
  Dashboard: {
    component: "Dashboard",
    edit: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM"],
    view: ["SYSTEM_IT", "PM", "SUPER_PM", "SUPPORT_PM", "CONTROLLER"],
  },
};

export const expenseRefundViewing = {
  expenseRefundFolderUsers: {
    edit: ["SYSTEM_IT"],
    view: ["SYSTEM_IT", "EXPENSE_REFUND_VIEW"],
  },
  approveExpenseReport: {
    edit: ["SYSTEM_IT", "HR", "ACCOUNTING", "PM", "RESP_CDC", "EXPENSE_REFUND_ADMIN"],
    view: ["SYSTEM_IT", "HR", "ACCOUNTING", "PM", "RESP_CDC", "EXPENSE_REFUND_ADMIN", "EXPENSE_REFUND_VIEW"],
  },
};

export const expenseRefundDisapprove = {
  disapproveExpenseReport: {
    edit: ["SYSTEM_IT", "ACCOUNTING", "EXPENSE_REFUND_ADMIN"],
    view: ["SYSTEM_IT", "ACCOUNTING", "EXPENSE_REFUND_ADMIN"],
  },
};

export const reportCPTabs = [
  {
    name: "financeStatementProgress",
    component: "financeStatementProgress",
    roles: ["SYSTEM_IT", "CONTROLLER", "CONSULTATION"],
  },
  {
    name: "incomeStatementProgress",
    component: "incomeStatementProgress",
    roles: ["SYSTEM_IT", "CONTROLLER", "CONSULTATION"],
  },
  {
    name: "projectsReport",
    component: "projectsReport",
    roles: ["SYSTEM_IT", "CONTROLLER", "CONSULTATION"],
  },
  {
    name: "kpiReport",
    component: "kpiReport",
    roles: [
      "SYSTEM_IT",
      "CONTROLLER",
      "SUPER_PM",
      "RESP_CDC",
      "PM",
      "SUPPORT_PM",
      "TIMESHEET_APPROVER",
      "CONSULTATION",
    ],
  },
];

export const reportTimesheet = [
  {
    name: "TimesheetReport",
    component: "TimesheetReport",
    roles: ["SYSTEM_IT", "CONTROLLER", "PM", "SUPER_PM", "SUPPORT_PM", "RESP_CDC", "TIMESHEET_APPROVER"],
  },
  {
    name: "TimesheetReportDetail",
    component: "TimesheetReportDetail",
    roles: ["SYSTEM_IT", "CONTROLLER", "PM", "SUPER_PM", "SUPPORT_PM", "RESP_CDC", "TIMESHEET_APPROVER"],
  },
  {
    name: "Squarings",
    component: "Squarings",
    roles: ["SYSTEM_IT", "CONTROLLER", "RESP_CDC", "TIMESHEET_APPROVER"],
  },
  {
    name: "PlannedVsTimesheetReport",
    component: "PlannedVsTimesheetReport",
    roles: ["SYSTEM_IT", "PM", "SUPER_PM"],
  },
];

export const secretKey = "hpmwCgbbVMktCBlC";

export const permittedFileFormatUpload = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
  "application/vnd.ms-excel", // xls
  "text/csv", // csv
  "text/plain", // txt
  "application/pdf", // pdf
  "application/msword", // doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
  "message/rfc822", // eml
  "application/vnd.ms-powerpoint", // ppt
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
];

export const permittedFileFormatUploadName = [
  ".xlsx",
  ".xls",
  ".csv",
  ".txt",
  ".pdf",
  ".doc",
  ".docx",
  ".eml",
  ".ppt",
  ".pptx",
];

export const fileFormatXextension = {
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
  xls: "application/vnd.ms-excel", // xls
  csv: ["text/csv", "application/vnd.ms-excel"], // csv
  txt: "text/plain", // txt
  pdf: "application/pdf", // pdf
  doc: "application/msword", // doc
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
  eml: "message/rfc822", // eml
  ppt: "application/vnd.ms-powerpoint", // ppt
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
};

export const mapMonths = {
  january: 1,
  february: 2,
  march: 3,
  april: 4,
  may: 5,
  june: 6,
  july: 7,
  august: 8,
  september: 9,
  october: 10,
  november: 11,
  december: 12,
};

export const timesheetFilterRoles = {
  date: ["SYSTEM_IT", "CONTROLLER", "PM", "SUPER_PM", "SUPPORT_PM", "RESP_CDC", "TIMESHEET_SUBSTITUTE"],
  user: ["SYSTEM_IT", "CONTROLLER", "RESP_CDC", "TIMESHEET_SUBSTITUTE"],
  projectActivity: ["SYSTEM_IT", "CONTROLLER", "PM", "SUPER_PM", "SUPPORT_PM"],
  service: ["SYSTEM_IT", "CONTROLLER"],
};

export const carFuel = ["BENZINE", "DIESEL"];

export const carCategory = ["CAR", "VAN", "TRUCK"];

export const flatRateTypes = ["ARRIVAL", "DEPARTURE"];

export const expenseRefundTypes = ["justification", "flat_rate", "km", "credit_card"];

export const permittedFlatRateUploadFormats = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/tiff",
  "image/webp",
  "image/heic",
  "image/heif",
];

export const maxFileFlatRate = 2097152; // 2MB

export const lgStatus = ["CREATED", "PLANNED", "EXECUTED", "TEMPORARY", "DEFINITIVE"];
